import axios from 'axios';
import changeSliderBg from './change-slider-bg';

export default () => {

    //load more for tables of: Reports, Presentations, Awards, Documents

    let loadMoreButton = document.getElementById("load-more-posts"),
        pageNumber = 1;

    function LoadMorePosts(el) {

        el.preventDefault();

        // el.setAttribute("disabled", true);
        // el.style.opacity='0.5';

        let e = el.target,
            tax = e.getAttribute("data-tax"),
            pages = e.getAttribute("data-pages"),
            ppp = e.getAttribute("data-ppp"),
            cpt = e.getAttribute("data-cpt"),
            offset = pageNumber * ppp,
            data = new URLSearchParams();

        e.setAttribute("disabled", true);
        e.style.opacity='0.7';

        data.append('action', 'more_cpt_post_ajax');
        data.append('offset', offset);
        data.append('ppp', ppp);
        data.append('cpt', cpt);
        data.append('tax', tax);

        let postsWrapper = document.getElementById('post-wrapper');

        axios.post('/wp-admin/admin-ajax.php', data)
            .then(function (response) {

                pageNumber++;

                postsWrapper.insertAdjacentHTML('beforeend', response.data);

                var pagesNum = parseInt(pages, 10);
                if (pageNumber === pagesNum) {
                    document.getElementById("load-more-posts").style.display = "none";
                    document.getElementById("load-more-posts").style.visibility = 'hidden';

                }
                changeSliderBg();
                e.removeAttribute("disabled");
                e.style.opacity='1';

            })
            .catch(function (error) {
                console.log(error);
            });

    }

    if (loadMoreButton) {
        loadMoreButton.onclick = LoadMorePosts;

    }

}